import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

const FORMAT = 'DD.MM.YYYY HH:mm';

export const formatLeakAlarmTime = (value, timeZone) => {
  if (!value) return '';

  const date = dayjs.utc(value);
  if (!date.isValid()) return '';

  if (!timeZone) return date.local().format(FORMAT);

  try {
    return date.tz(timeZone).format(FORMAT);
  } catch {
    return date.local().format(FORMAT);
  }
};
